import { DiscountBadge } from 'QuoteApp/components/DiscountBadge';
import React, { FC } from 'react';
import styles from './styles.module.css';
import { Button } from '@clearcover/atlas';

export type HeaderButton = {
  text: string;
  onClick: () => void;
  disabled?: boolean;
};

export type SummarySectionProps = {
  discountBadgeText?: string;
  headerText: string;
  subHeaderText?: string;
  children?: React.ReactNode;
  headerButton?: HeaderButton;
};

export const SummarySection: FC<SummarySectionProps> = ({
  discountBadgeText,
  headerText,
  subHeaderText,
  children,
  headerButton,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.headerWrapper}>
        <h3 className={styles.header}>
          {headerText}
          {discountBadgeText && (
            <DiscountBadge className={styles.discountBadge}>
              {discountBadgeText}
            </DiscountBadge>
          )}
        </h3>
        {headerButton && (
          <Button
            type="button"
            variant="secondary"
            onClick={headerButton.onClick}
            className={styles.headerButton}
            disabled={headerButton.disabled}
          >
            {headerButton.text}
          </Button>
        )}
      </div>
      <div className={styles.subText}>{subHeaderText}</div>
      {children}
    </div>
  );
};
